import React from 'react';
interface Props {
  onClose: (ok: boolean) => void;
}

const SessionExpiredModal: React.FC<Props> = ({ onClose }) => (
  <div className={'content'}>
    <div className={'modal-title'}>Moderation Session Has Timed Out!</div>
    <div className={'modal-description'}>Click Ok to receive new comments</div>
    <div className={'button-container'}>
      <div className={'confirm modal-button'} onClick={() => onClose(true)}>
        OK
      </div>
      <div className={'dismiss modal-button'} onClick={() => onClose(false)}>
        Cancel
      </div>
    </div>
  </div>
);

export { SessionExpiredModal };
